import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home.vue'
import NewVisa from '@/components/NewVisa.vue'
import Images from '@/components/Images.vue'
import Final from '@/components/Final.vue'
import Status from '@/components/Status.vue'
import PrePayment from '@/components/PrePayment.vue'
import PaymentOK from '@/components/PaymentOK.vue'
import PaymentNotOK from '@/components/PaymentNotOK.vue'
import AppDetailsVue from '../components/AppDetails.vue'
import Authorise from '../components/Authorise.vue'
import NeedVisa from '../components/NeedVisa.vue'
import ReqPhoto from '../components/ST_ReqPhoto.vue'
import ReqPassport from '../components/ST_ReqPassport'
import VisaProcess from '../components/ST_VisaProcess.vue'
import Location from '../components/ST_Location.vue'
import AboutBW from '../components/ST_AboutBW.vue'
import Climate from '../components/ST_Climate.vue'
import Terms from '../components/ST_Terms.vue'
import AppTerms from '../components/ST_AppTerms.vue'
import Covid from '../components/ST_Covid.vue'
import Contact from '../components/ST_Contact.vue'
import Temp from '../components/ST_Temp.vue'

Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/NewVisa',
            name: 'NewVisa',
            component: NewVisa
        },
        {
            path: '/images',
            name: 'Images',
            component: Images
        },
        {
            path: '/final',
            name: 'Final',
            component: Final
        },
        {
            path: '/status',
            name: 'Status',
            component: Status
        },
        {
            path: '/prepayment',
            name: 'PrePayment',
            component: PrePayment
        },
        {
            path: '/paymentok',
            name: 'PaymentOK',
            component: PaymentOK
        },
        {
            path: '/paymentnotok',
            name: 'PaymentNotOK',
            component: PaymentNotOK
        },
        {
            path: '/appdetails',
            name: 'AppDetails',
            component: AppDetailsVue
        },
        {
            path: '/authorise',
            name: 'Authorise',
            component: Authorise
        },
        {
            path: '/needvisa',
            name: 'NeedVisa',
            component: NeedVisa
        },
        {
            path: '/req_photo',
            name: ReqPhoto,
            component: ReqPhoto
        },
        {
            path: '/req_passport',
            name: ReqPassport,
            component: ReqPassport
        },
        {
            path: '/visaprocess',
            name: 'VisaProcess',
            component: VisaProcess
        },
        {
            path: '/location',
            name: Location,
            component: Location
        },
        {
            path: '/about',
            name: AboutBW,
            component: AboutBW
        },
        {
            path: '/climate',
            name: Climate,
            component: Climate
        },
        {
            path: '/terms',
            name: Terms,
            component: Terms
        },
        {
            path: '/appterms',
            name: AppTerms,
            component: AppTerms
        },
        {
            path: '/covid',
            name: Covid,
            component: Covid
        },
        {
            path: '/contact',
            name: Contact,
            component: Contact
        }
    ]
})
